import { render } from "./ResponsiveGridItem.vue?vue&type=template&id=b2f97cf0&scoped=true"
import script from "./ResponsiveGridItem.vue?vue&type=script&lang=js"
export * from "./ResponsiveGridItem.vue?vue&type=script&lang=js"

import "./ResponsiveGridItem.vue?vue&type=style&index=0&id=b2f97cf0&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f97cf0"]])

export default __exports__